import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { getBadgeType, getTitle } from 'utils/badge-utils';
import { registerSocket, deregisterSocket } from 'services/socket';

import MenuAlert from './menu-alert';


class TicketMenuAlert extends React.Component {
  static propTypes = {
    currentUser: PropTypes.object
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    registerSocket('taskStatus', (message) => {
      this.setState({ taskAlert: message });
    });
  }
  
  componentWillUnmount() {
    deregisterSocket('taskStatus');
  }

  render() {
    const { currentUser } = this.props;
    const { taskAlert } = this.state;
    const alerts = _.get(taskAlert, currentUser.id, {});
    const badge = getBadgeType(alerts);
    const title = getTitle(alerts);

    if (!alerts.total) return null;

    return (
      <MenuAlert title={title} className={`badge-${badge}`}>{alerts.total}</MenuAlert>
    );
  }
}

export default connect((state) => ({
  currentUser: state.auth.currentUser
}))(TicketMenuAlert);



// WEBPACK FOOTER //
// ./app/components/main-menu/components/ticket-menu-alert.js